<div class="background-layer-1"></div>
<div class="background-layer-2"></div>

<form class="websynapse-login" [formGroup]="loginForm" (document:keydown.control.shift.z)="automaticLogin()">
  <div class="grid__row">
    <div class="login">
      <div class="p-grid">
        <div class="p-col-12 p-mb-4">
          <div class="logo"></div>
        </div>

        <div class="p-fluid p-col-12 p-mb-6 narrow">
          <span class="p-float-label">
            <input
              pInputText
              id="userName"
              type="text"
              formControlName="username"
              [style]="{ backgroundColor: 'transparent' }"
              (keydown.enter)="login()"
            />
            <label for="userName">User Name</label>
          </span>
        </div>

        <div class="p-fluid p-col-12 p-mb-6 narrow">
          <span class="p-float-label">
            <input
              pPassword
              id="userPassword"
              type="password"
              formControlName="password"
              [style]="{ backgroundColor: 'transparent' }"
              [feedback]="false"
              (keydown.enter)="login()"
            />
            <label for="userPassword">Password</label>
          </span>
        </div>

        <div class="p-fluid p-col-12 narrow">
          <p-button label="Login" (click)="login()"></p-button>
        </div>

        <div class="p-col">
          <app-loader-spinner [display]="submitted"></app-loader-spinner>
        </div>

        <div class="version">
          v{{ version$ | async }} {{ environment$ | async }}
        </div>
      </div>
    </div>
  </div>
</form>

<app-modal-dialog></app-modal-dialog>

<p-confirmDialog
  #messageDialog
  key="auth-message"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '50vw', backgroundColor: '#fff' }"
>
  <ng-template pTemplate="footer">
    <p-button label="Ok" (click)="messageDialog.accept()" styleClass="p-button-outlined p-button-secondary"></p-button>
  </ng-template>
</p-confirmDialog>
